import { render, staticRenderFns } from "./WordDisplay.vue?vue&type=template&id=658acf1d&scoped=true"
import script from "./WordDisplay.vue?vue&type=script&lang=js"
export * from "./WordDisplay.vue?vue&type=script&lang=js"
import style0 from "./WordDisplay.vue?vue&type=style&index=0&id=658acf1d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658acf1d",
  null
  
)

export default component.exports